// extracted by mini-css-extract-plugin
module.exports = {"i158p38v":"i158p38v","b1q1fqwx":"b1q1fqwx"};